var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.wrapper,on:{"click":_vm.navigateTo}},[_c('font-awesome-icon',{class:_vm.$style.icon,attrs:{"icon":"arrow-left"}}),_c('div',{class:_vm.$style.text,domProps:{"textContent":_vm._s(_vm.$locale.baseText('template.buttons.goBackButton'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }